import {DataFetcher, useGrpcRequest} from '@aboutyou/data-fetcher';
import React, {FC} from 'react';
import {SubscribeToNewsletterRequest_Gender} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/newsletter_subscription/v1/service.types';
import {NewsletterSubscriptionService_SubscribeToNewsletter} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/newsletter_subscription/v1/service.grpc';
import {useOptionalSession} from '@aboutyou/user';
import {
  LoadingPageSpinner,
  InfoPopup as StatusPopup,
} from '@aboutyou/ui-components';
import {useTranslation} from '@aboutyou/i18n';

const SuccessView: FC<{
  resetForm: () => void;
}> = ({resetForm}) => {
  const {t} = useTranslation();

  return (
    <StatusPopup
      headline={t('Just one step left!')}
      onClose={resetForm}
      showCloseIcon
      subline={t(
        'Please confirm your registration by clicking on the link in the email we have just sent you.',
      )}
      type="success"
      timeToAutoClose={5000}
      dataTestId={'statusPopupSuccess'}
    />
  );
};

export const SubscribeToNewsletter: React.FC<{
  email: string;
  gender: 'female' | 'male';
  resetForm: () => void;
}> = ({email, gender, resetForm}) => {
  return (
    <DataFetcher
      request={useSubscribeToNewsletter({email, gender})}
      Loading={LoadingPageSpinner}
      View={SuccessView}
      viewProps={{resetForm}}
      Error={null}
    />
  );
};

const useSubscribeToNewsletter = ({
  email,
  gender,
}: {
  email: string;
  gender: 'female' | 'male';
}) => {
  const session = useOptionalSession();

  return useGrpcRequest(NewsletterSubscriptionService_SubscribeToNewsletter, {
    email,
    gender:
      gender === 'female'
        ? SubscribeToNewsletterRequest_Gender.GENDER_FEMALE
        : SubscribeToNewsletterRequest_Gender.GENDER_MALE,
    session,
  });
};
